import { useEffect, useState } from "react"

const CLARA_API = window.env?.REACT_APP_CLARA_API_URL

// The stored PDF as a local URL, from the same token-guarded file route a source card opens.
export function usePdfUrl(document, workspace, getToken) {
	const [url, setUrl] = useState(null)
	const [error, setError] = useState(null)

	useEffect(() => {
		let objectUrl = null
		let cancelled = false
		setUrl(null)
		setError(null)
		if (!document?.has_original) return undefined
		// no-store: after Replace file the same URL serves a new PDF.
		fetch(`${CLARA_API}/documents/${document.id}/file?workspace_name=${encodeURIComponent(workspace)}`, { headers: { Authorization: getToken() }, cache: "no-store" })
			.then(async response => {
				if (!response.ok) throw new Error((await response.text()) || `status ${response.status}`)
				return response.blob()
			})
			.then(blob => {
				if (cancelled) return
				objectUrl = URL.createObjectURL(blob)
				setUrl(objectUrl)
			})
			.catch(e => !cancelled && setError(e.message))
		return () => {
			cancelled = true
			if (objectUrl) URL.revokeObjectURL(objectUrl)
		}
	}, [document?.id, document?.has_original, document?.byte_size, workspace, getToken])

	return { url, error }
}
